__turbopack_context__.v({
  "badge": "ThemeSelector-module__KGxbHq__badge",
  "card": "ThemeSelector-module__KGxbHq__card",
  "cardActive": "ThemeSelector-module__KGxbHq__cardActive",
  "compact": "ThemeSelector-module__KGxbHq__compact",
  "desc": "ThemeSelector-module__KGxbHq__desc",
  "dropdownBody": "ThemeSelector-module__KGxbHq__dropdownBody",
  "dropdownFoot": "ThemeSelector-module__KGxbHq__dropdownFoot",
  "dropdownHead": "ThemeSelector-module__KGxbHq__dropdownHead",
  "dropdownLead": "ThemeSelector-module__KGxbHq__dropdownLead",
  "dropdownOverlay": "ThemeSelector-module__KGxbHq__dropdownOverlay",
  "dropdownSection": "ThemeSelector-module__KGxbHq__dropdownSection",
  "dropdownTitle": "ThemeSelector-module__KGxbHq__dropdownTitle",
  "footer": "ThemeSelector-module__KGxbHq__footer",
  "grid": "ThemeSelector-module__KGxbHq__grid",
  "meta": "ThemeSelector-module__KGxbHq__meta",
  "modeBtn": "ThemeSelector-module__KGxbHq__modeBtn",
  "modeBtnActive": "ThemeSelector-module__KGxbHq__modeBtnActive",
  "modeRow": "ThemeSelector-module__KGxbHq__modeRow",
  "modeSegment": "ThemeSelector-module__KGxbHq__modeSegment",
  "modeSegmentActive": "ThemeSelector-module__KGxbHq__modeSegmentActive",
  "modeSegmented": "ThemeSelector-module__KGxbHq__modeSegmented",
  "name": "ThemeSelector-module__KGxbHq__name",
  "panel": "ThemeSelector-module__KGxbHq__panel",
  "root": "ThemeSelector-module__KGxbHq__root",
  "sectionLabel": "ThemeSelector-module__KGxbHq__sectionLabel",
  "settingsLink": "ThemeSelector-module__KGxbHq__settingsLink",
  "swatch": "ThemeSelector-module__KGxbHq__swatch",
  "swatchRow": "ThemeSelector-module__KGxbHq__swatchRow",
  "themeList": "ThemeSelector-module__KGxbHq__themeList",
  "themeRow": "ThemeSelector-module__KGxbHq__themeRow",
  "themeRowActive": "ThemeSelector-module__KGxbHq__themeRowActive",
  "themeRowCheck": "ThemeSelector-module__KGxbHq__themeRowCheck",
  "themeRowCheckPlaceholder": "ThemeSelector-module__KGxbHq__themeRowCheckPlaceholder",
  "themeRowCopy": "ThemeSelector-module__KGxbHq__themeRowCopy",
  "themeRowDesc": "ThemeSelector-module__KGxbHq__themeRowDesc",
  "themeRowName": "ThemeSelector-module__KGxbHq__themeRowName",
  "themeRowSwatch": "ThemeSelector-module__KGxbHq__themeRowSwatch",
  "trigger": "ThemeSelector-module__KGxbHq__trigger",
  "triggerChevron": "ThemeSelector-module__KGxbHq__triggerChevron",
  "triggerCopy": "ThemeSelector-module__KGxbHq__triggerCopy",
  "triggerMode": "ThemeSelector-module__KGxbHq__triggerMode",
  "triggerSwatches": "ThemeSelector-module__KGxbHq__triggerSwatches",
  "triggerTheme": "ThemeSelector-module__KGxbHq__triggerTheme",
});
